var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{ref:"elUpload",staticStyle:{"display":"none"},attrs:{"action":"","limit":1,"accept":".xls,.xlsx","show-file-list":false,"http-request":_vm.handleHttpRequest}},[_c('i',{ref:"upload"})])}
var staticRenderFns = []

export { render, staticRenderFns }